import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { categorySales: { categorySales } } = apiUrls;

export const CATEGORY_SALES_SUCCESS = 'CATEGORY_SALES_SUCCESS';
export const SALES_CATEGORY_BY_MONTH_LOADING = 'SALES_CATEGORY_BY_MONTH_LOADING';

export const getCategorySalesData = ({ from, to, vendor }) => async (dispatch) => {

    try {
        if (vendor) {
            const requestData = {
                ...categorySales,
                url: categorySales.url.replace('{from}', from).replace('{to}', to).replace("{{vendor}}", vendor)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: CATEGORY_SALES_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: CATEGORY_SALES_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }

}

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: SALES_CATEGORY_BY_MONTH_LOADING,
            isLoading,
            vendor
        });
    }
}